import { Injectable } from '@angular/core';
import { BaseService, LeagueApi, LeagueBanner, MediaApi, MediaItem } from '@mtgame/core';
import { Observable } from 'rxjs';

const STORE_MEDIA_KEY = 'media';
const STORE_BANNERS_KEY = 'banners';

@Injectable()
export class TournamentTeamPhotosService extends BaseService {
  leagueId: number;
  teamId: number;
  page = 1;
  size = 12;
  total: number;

  get media$(): Observable<MediaItem[]> {
    return this.store.get(STORE_MEDIA_KEY);
  }

  get banners$(): Observable<LeagueBanner[]> {
    return this.store.get(STORE_BANNERS_KEY);
  }

  constructor(
    private mediaApi: MediaApi,
    private leagueApi: LeagueApi,
  ) {
    super();
  }

  async initialize(leagueId: number, teamId: number): Promise<any> {
    this.page = 1;
    this.leagueId = leagueId;
    this.teamId = teamId;
    return Promise.all([this.loadMedia(), this.getBanners()]);
  }

  async loadMedia(): Promise<MediaItem[]> {
    const media = await this.mediaApi.getLeagueMedia(this.leagueId, this.page, this.size, {mediaType: 'photo', teamId: this.teamId});
    if (this.page === 1) {
      this.store.save(STORE_MEDIA_KEY, media.data);
      this.total = media.total;
    } else {
      this.store.appendItems(STORE_MEDIA_KEY, media.data);
    }
    return media.data;
  }

  async loadNextPage(): Promise<MediaItem[]> {
    if (this.page * this.size >= this.total) {
      return Promise.resolve([]);
    }
    this.page++;
    return this.loadMedia();
  }

  async getBanners(): Promise<LeagueBanner[]> {
    const banners = await this.leagueApi.getBanners(this.leagueId);
    this.store.save(STORE_BANNERS_KEY, banners);
    return banners;
  }
}
